"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistogram__Wrapper",
  componentId: "sc-11dn1mt-0"
})(["\n  width: 100%;\n  height: ", ";\n  display: flex;\n  flex-direction: ", ";\n  align-items: stretch;\n  background-color: #fff;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"], function (props) {
  return props.height;
}, function (props) {
  return props.rotate ? "column-reverse" : "row";
});

var YAxisCnt = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistogram__YAxisCnt",
  componentId: "sc-11dn1mt-1"
})(["\n  flex-grow: 0;\n  flex-shrink: 1;\n  direction: ", ";\n"], function (props) {
  return props.rotate ? "rtl" : "ltr";
});

var YAxis = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistogram__YAxis",
  componentId: "sc-11dn1mt-2"
})(["\n  ", ": calc(100% - 40px);\n  ", ": 100%;\n  ", "\n\n  display: grid;\n  grid-template-", ": repeat(", ", 1fr);\n  grid-gap: 0px;\n"], function (props) {
  return props.rotate ? "width" : "height";
}, function (props) {
  return props.rotate ? "height" : "width";
}, function (props) {
  return props.rotate ? "margin-left: 40px;" : "";
}, function (props) {
  return props.rotate ? "columns" : "rows";
}, function (props) {
  return props.steps + 1;
});

var YAxisLabel = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistogram__YAxisLabel",
  componentId: "sc-11dn1mt-3"
})(["\n  font-size: 10px;\n  letter-spacing: 0px;\n  ", "\n"], function (props) {
  return props.rotate ? "\n    position: relative;\n    left: -50%;\n  " : "\n    text-align: right;\n    padding-right: 5px;\n    transform: translateY(6px);\n    display: flex;\n    justify-content: end;\n    align-items: end;\n    white-space: nowrap;  \n  ";
});

var ContentCnt = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistogram__ContentCnt",
  componentId: "sc-11dn1mt-4"
})(["\n  flex-grow: 1;\n  flex-shrink: 1;\n  position: relative;\n"]);

var Content = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistogram__Content",
  componentId: "sc-11dn1mt-5"
})(["\n  ", ": calc(100% - 40px);\n  ", ": 100%;\n  ", "\n  position: relative;\n"], function (props) {
  return props.rotate ? "width" : "height";
}, function (props) {
  return props.rotate ? "height" : "width";
}, function (props) {
  return props.rotate ? "margin-left: 40px;" : "";
});

var YAxisLineCnt = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistogram__YAxisLineCnt",
  componentId: "sc-11dn1mt-6"
})(["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-", ": repeat(", ", 1fr);\n  grid-gap: 0px;\n"], function (props) {
  return props.rotate ? "columns" : "rows";
}, function (props) {
  return props.steps + 1;
});

var YAxisLine = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistogram__YAxisLine",
  componentId: "sc-11dn1mt-7"
})(["\n  border-", ": 1px solid #dedede;\n"], function (props) {
  return props.rotate ? "left" : "bottom";
});

var BarsCnt = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistogram__BarsCnt",
  componentId: "sc-11dn1mt-8"
})(["\n  position: absolute;\n  top: -5px;\n  left: 0px;\n  width: 100%;\n  height: calc(100% + 5px);\n  display: grid;\n  grid-template-", ": repeat(", ", 1fr);\n  grid-gap: ", ";\n  align-items: end;\n  direction: ", ";\n"], function (props) {
  return props.rotate ? "rows" : "columns";
}, function (props) {
  return props.columns;
}, function (props) {
  return props.stretch ? "5px" : "0px";
}, function (props) {
  return props.rotate ? "ltr" : "rtl";
});

var BarCnt = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistogram__BarCnt",
  componentId: "sc-11dn1mt-9"
})(["\n  position: relative;\n  display: flex;\n  flex-direction: ", ";\n  background: ", ";\n  justify-content: flex-end;\n  ", ": ", "%;\n  ", ": 100%;\n  align-items: center;\n"], function (props) {
  return props.rotate ? "row-reverse" : "column";
}, function (props) {
  return props.background ? props.background : "transparent";
}, function (props) {
  return props.rotate ? "width" : "height";
}, function (props) {
  return props.height;
}, function (props) {
  return props.rotate ? "height" : "width";
});

var Bar = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistogram__Bar",
  componentId: "sc-11dn1mt-10"
})(["\n  cursor: ", ";\n  position: relative;\n  ", ": 100%;\n  ", ": ", "%;\n\n  & span{\n    display: none;\n    position: absolute;\n    white-space: nowrap;\n    text-align: center;\n    font-size: 10px;\n    letter-spacing: 0px;\n    z-index: 9;\n  \n    ", ";\n\n\n\n  }\n  &:hover span{\n    display: block;\n  }\n\n  &:after{\n    content: \"\";\n    display: block;\n    // position: absolute;\n    margin: 0 auto;\n    bottom: 0px;\n    // left: 0px;\n    width: 100%;\n    height: 100%;\n    ", ": ", ";\n    ", "\n    // border-", ": 1px solid white;\n\n  }\n\n  &:hover:after{\n    ", "\n  }\n"], function (props) {
  return props.hasCallback ? "pointer" : "default";
}, function (props) {
  return props.rotate ? "height" : "width";
}, function (props) {
  return props.rotate ? "width" : "height";
}, function (props) {
  return props.value;
}, function (props) {
  return props.rotate ? "\n      right: 0px;\n      margin-top: -5px;\n      transform: translateX(50%);\n    " : "\n      bottom: calc(100% - 10px);\n      left: 50%;\n      transform: translateX(-50%);\n    ";
}, function (props) {
  return props.rotate ? "height" : "width";
}, function (props) {
  return props.stretch ? "100%" : "3px";
}, function (props) {
  return props.empty ? "\n      background-color:  " + (props.barColor ? props.barColor : "#E8EBEDCC") + ";\n    " : "\n      background-color:  " + (props.barColor ? props.barColor : "#687fe2CC") + ";\n    ";
}, function (props) {
  return props.rotate ? "right" : "top";
}, function (props) {
  return !props.empty ? "\n      background-color:  " + (props.barColorHover ? props.barColorHover : "#687fe2") + ";\n    " : null;
}); // const XAxis = styled.div`
//   width: 100%;
//   height: 30px;
//   display: grid;
//   grid-template-columns: repeat(${props => props.columns}, 1fr);
//   grid-gap: 15px;
// `;


var XAxisLabel = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistogram__XAxisLabel",
  componentId: "sc-11dn1mt-11"
})(["\n  position: absolute;\n  color: ", ";\n  ", "\n"], function (props) {
  return props.color ? props.color : "inherit";
}, function (props) {
  return props.rotate ? "\n    height: 100%;\n    width: 36px;\n    margin-left: -40px;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  " : "\n    bottom: -40px;\n    width: 100%;\n    font-size: 9px;\n    letter-spacing: 0px;\n    text-align: center;\n  ";
});

var OzChartHistogram = function OzChartHistogram(_ref) {
  var _ref$rotate = _ref.rotate,
      rotate = _ref$rotate === void 0 ? false : _ref$rotate,
      _ref$stretch = _ref.stretch,
      stretch = _ref$stretch === void 0 ? false : _ref$stretch,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "300px" : _ref$height,
      max = _ref.max,
      steps = _ref.steps,
      values = _ref.values,
      fnCallback = _ref.fnCallback,
      _ref$fnFormatValue = _ref.fnFormatValue,
      fnFormatValue = _ref$fnFormatValue === void 0 ? function (ret) {
    return ret.value;
  } : _ref$fnFormatValue,
      _ref$fnFormatY = _ref.fnFormatY,
      fnFormatY = _ref$fnFormatY === void 0 ? function (ret) {
    return ret;
  } : _ref$fnFormatY;
  var maxY = max ? max : Math.max.apply(Math, (0, _toConsumableArray2.default)(values.map(function (items) {
    return items.bars.reduce(function (tot, item) {
      return tot + item.value;
    }, 0);
  })));
  var letMaxYLength = parseInt(maxY).toString().length;

  if (letMaxYLength > 2) {
    maxY = (parseInt(maxY.toString().substring(0, 2)) + 1) * Math.pow(10, letMaxYLength - 2);
  } else {
    maxY = (parseInt(maxY.toString().substring(0, 1)) + 1) * Math.pow(10, letMaxYLength - 1);
  }

  if (!steps) {
    for (var i = 10; i > 2; i--) {
      if (maxY * 2 % i === 0) {
        steps = i;
        break;
      }
    }

    if (!steps) {
      steps = 10;
    }
  }

  var labelsY = [];
  var stepY = maxY / steps;

  for (var _i = steps; _i >= 0; _i--) {
    if (stepY < 1) {
      labelsY.push((_i * stepY).toFixed(1));
    } else {
      labelsY.push(_i * stepY);
    }
  }

  return __jsx(Wrapper, {
    height: height,
    rotate: rotate ? 1 : undefined
  }, __jsx(YAxisCnt, {
    rotate: rotate ? 1 : undefined
  }, __jsx(YAxis, {
    steps: steps,
    rotate: rotate ? 1 : undefined
  }, labelsY.map(function (item, i) {
    return __jsx(YAxisLabel, {
      key: i,
      rotate: rotate ? 1 : undefined
    }, fnFormatY(item));
  }))), __jsx(ContentCnt, null, __jsx(Content, {
    rotate: rotate ? 1 : undefined
  }, __jsx(YAxisLineCnt, {
    rotate: rotate ? 1 : undefined,
    steps: steps
  }, labelsY.map(function (item, i) {
    return __jsx(YAxisLine, {
      rotate: rotate ? 1 : undefined,
      key: i
    });
  })), __jsx(BarsCnt, {
    columns: values.length,
    rotate: rotate ? 1 : undefined,
    stretch: stretch
  }, values.map(function (value, i) {
    return __jsx(BarCnt, {
      rotate: rotate ? 1 : undefined,
      key: i,
      height: steps * 100 / (steps + 1),
      background: value.style && value.style.background ? value.style.background : null
    }, value.bars.map(function (bar, j) {
      return bar.value ? __jsx(Bar, {
        key: i + "-" + j,
        hasCallback: fnCallback ? 1 : 0,
        onClick: fnCallback ? function () {
          return fnCallback(bar);
        } : function () {},
        empty: bar.value === null,
        "data-value": bar.value + " * 100 / " + maxY,
        value: bar.value * 100 / maxY,
        rotate: rotate ? 1 : undefined,
        stretch: stretch,
        barColor: bar.style && bar.style.barColor ? bar.style.barColor : null,
        barColorHover: bar.style && bar.style.barColorHover ? bar.style.barColorHover : null
      }, bar.value ? __jsx("span", null, fnFormatValue(bar)) : null) : null;
    }), __jsx(XAxisLabel, {
      color: value.style && value.style.labelColor ? value.style.labelColor : null,
      rotate: rotate ? 1 : undefined
    }, value.label));
  }).reverse()))));
};

var _default = OzChartHistogram;
exports.default = _default;